<script>
  import config from '../../libs/config.js';
  import { mapGetters, mapActions } from 'vuex'
  
  import api from '../../api/public'
  import api_private from '../../api'

  import _system from '../../libs/system';

  import axios from 'axios'

  import AOS from 'aos'
  import 'aos/dist/aos.css'

   import { db } from '../../firebase';

	export default 
	{
    name: 'signin',
    data(){
      return {
        config: config,
        loading: false,
        mobile: false,
        show: false,
        showLogin: false,
        tokenBody: '',
        tokenUser: {},
        whiteLabelLogo: '',
        shopifyUrl:'',
        signIn: {
          email: '',
          password: ''
        },
        error: {
          email: {
            invalid: false,
            notExist: false
          },
          password: {
            invalid: false
          }
        }
      }
    },
    mounted(){

        let domain = window.location.hostname.toString();

        if(domain == 'app.juphy.com' || domain == 'localhost'){
          this.show = true
        }else{
          
        db.collection('domains')
        .doc(domain.replaceAll('.',''))
        .get()
        .then(snapshot => {
          const document = snapshot.data()
          this.whiteLabelLogo = document.url
        }).catch(()=>{
          console.log('Error reading one document.')
        })
        }
    },
    created(){
      AOS.init();

        if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) this.mobile = true;

        if(this.$route.query.system == 'reset'){
          localStorage.clear();
          window.location.href = '/logout';
        } 


        // https://198a4b-2.myshopify.com/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https://juphy-api2.ngrok.io/shopify/redirect&grant_options%5B%5D=per-user&prompt=consent&scope=read_orders%2Cread_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content

        // https://198a4b-2.myshopify.com/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https%3A%2F%2Fapi.juphy.com%2Fshopify%2Fredirect&grant_options%5B%5D=per-user&prompt=consent&scope=read_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content

        // https://198a4b-2.myshopify.com/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https%3A%2F%2Fapi.juphy.com%2Fshopify%2Fredirect&grant_options%5B%5D=per-user&prompt=consent&scope=read_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content

        if(this.$route.query.shop && this.$route.query.shop.length){
          let _state = encodeURIComponent(JSON.stringify({userId: "", workspaceId: "",redirect_url: config.shopify.redirect.url}));
          
          return window.location.href = 'https://'+ this.$route.query.shop +'/admin/oauth/authorize?state=' + _state + '&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=' + config.shopify.redirect.url + '&prompt=consent&scope=read_orders%2Cread_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content&grant_options%5B%5D=per-user'
        }else{
          this.showLogin = true;
        }

        //encodeURIComponent(JSON.stringify({userId: "", workspaceId: "",redirect_url: "https://juphy-api2.ngrok.io/shopify/redirect"}))


        //https://evergreenoutdoor.store/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%2C%22redirect_url%22%3A%22https%3A%2F%2Fjuphy-api2.ngrok.io%2Fshopify%2Fredirect%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https://juphy-api2.ngrok.io/shopify/redirect&prompt=consent&scope=read_orders%2Cread_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content

        //https://juphy-api2.ngrok.io/shopify/signin?shop=evergreenoutdoor.store&redirect_uri=https://juphy-api2.ngrok.io/shopify/redirect

        //https://evergreenoutdoor.store/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%2C%22redirect_url%22%3A%22https%3A%2F%2Fjuphy-api2.ngrok.io%2Fshopify%2Fredirect%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https://juphy-api2.ngrok.io/shopify/redirect&prompt=consent&scope=read_orders%2Cread_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content&grant_options%5B%5D=per-user

        //https://evergreenoutdoor.store/admin/oauth/authorize?state=%7B%22userId%22%3A%22%22%2C%22workspaceId%22%3A%22%22%7D&client_id=2316679a1744bbd29e22e8b6134920e6&redirect_uri=https://juphy-api2.ngrok.io/shopify/redirect&prompt=consent&scope=read_orders%2Cread_products%2Cread_product_listings%2Cread_themes%2Cwrite_themes%2Cread_content&grant_options%5B%5D=per-user


        //grant_options%5B%5D=per-user
        //&grant_options[]=''
        
        //localhost:3333/signin?accessToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InVzZXIiOnsiZW1haWwiOiJidXJjdUBwYWNpZmljLW9jZWFuLmNvbSIsIl9pZCI6IjY1ODEyMGUwMTg0ZjhjZWQ0MjQwZDU1NSIsIm5hbWUiOiJCdXJjdSBZaWxtYXoiLCJ0YWdzIjpbXX19LCJpYXQiOjE3MDY4MjgxNzMsImV4cCI6MTcxNzE5NjE3M30.FDffCAJL6hXQXSaCut3goH88At2GZYFSd4_Bd1x2u3Q&platform=shopify&editorUrl=https%3A%2F%2Fevergreenoutdoor.store%2Fadmin%2Fthemes%2Fcurrent%2Feditor%3FappEmbed%3Df68438fc-3793-4355-a683-ded84ca39046%2Fjuphy-widget%26context%3Dapps%26activateAppId%3Df68438fc-3793-4355-a683-ded84ca39046%2Fjuphy-widget&pageId=658120e1184f8ced4240d5c6

          if(this.$route.query.accessToken && this.$route.query.accessToken.length && this.$route.query.platform && this.$route.query.platform.length){

            console.log(this.$route.query)

          let t = this.$route.query.accessToken;
          this.tokenBody = JSON.parse(window.atob(t.split('.')[1]));

          this.tokenBody.data.user.themeEditorUrl = this.$route.query.editorUrl
          this.tokenBody.data.user.themeCurrentPageId = this.$route.query.pageId

          localStorage.clear();

          this.login({
            jwt: t,
            user: this.tokenBody.data.user
          });

          //http://localhost:3333/signin?accessToken=&platform=shopify&editorUrl=123456
          this.setIsLoggedIn();   

              return this.$router.push({ "path": "widget"});

        }else if(this.isLoggedIn){
           return window.location.href = '/logout'
        }
      

        if(this.$route.query.t && this.$route.query.t.length && this.$route.query.reset && this.$route.query.reset == 'true'){

          let t = this.$route.query.t;
          this.tokenBody = JSON.parse(window.atob(t.split('.')[1]));
          //this.tokenUser = this.tokenBody.data.user

          localStorage.clear();

              this.login({
                jwt: t,
                user: this.tokenBody.data.user
              });
                                        
              this.setIsLoggedIn();   

              return this.$router.push({ "path": "account" });

        }else if(this.isLoggedIn){
           return window.location.href = '/logout'
        }

        if(this.$route.query.t && this.$route.query.t.length){

          let t = this.$route.query.t;
          this.tokenBody = JSON.parse(window.atob(t.split('.')[1]));
          //this.tokenUser = this.tokenBody.data.user

          localStorage.clear();

              this.login({
                jwt: t,
                user: this.tokenBody.data.user
              });
                                        
              this.setIsLoggedIn();   

              return this.$router.push({ "path": "account" });

        }else if(this.isLoggedIn){
           return window.location.href = '/logout'
        }

        if(this.$route.query.accessToken && this.$route.query.accessToken.length){

          let t = this.$route.query.accessToken;
          this.tokenBody = JSON.parse(window.atob(t.split('.')[1]));
          //this.tokenUser = this.tokenBody.data.user

          localStorage.clear();

              this.login({
                jwt: t,
                user: this.tokenBody.data.user
              });
                                        
              this.setIsLoggedIn();   

              return this.$router.push({ "path": "account" });

        }else if(this.isLoggedIn){
           return window.location.href = '/logout'
        }
      


    },
    computed:{
      ...mapGetters('session', ['isLoggedIn', , 'getUser', 'getJwt'])
    },
    methods: 
      {
        ...mapActions('session', ['login', 'setIsLoggedIn', 'setWorkspace']),
        ...mapActions('networks', ['setNetworks']),
        ...mapActions('statuses', ['setStatuses']),
        signInFunc()
        {

        if(!this.signIn.email.length || !this.signIn.password.length ){
            return alert('Inputs cannot be empty')
        }

          this.loading = true;

          this.signIn.email = this.signIn.email.trim();
          this.signIn.password = this.signIn.password.trim();


          
          //User Sign In
          api.postHeader("/authentication/authenticate", this.signIn, (err, data) => {

              if(err) {
              if(err.headers['x-redirect']){
                return window.location.replace(err.headers['x-redirect']);
              }
                this.loading = false
                this.error.message = err.data.message
                return this.error.email.invalid = true;
            }

            if(data.headers['x-redirect']){
              return window.location.replace(data.headers['x-redirect']);
            }

              data = data.data;


              data.user.brand = {}

              data.user.email = this.signIn.email.trim();

              this.login({
                jwt: data.accessToken,
                user: data.user
              });
                                        
              this.setIsLoggedIn();    
              this.loaded = true
                   
              this.loading = false
              this.$router.push({ "path": "inbox" });


          });
		    }
		}
	}
</script>

<template>
		<div :class="(mobile) ? 'ui grid stackable padded' : 'ui grid stackable middle aligned padded'">
      <div class="six wide column centered">
          <div v-if="show" data-aos="zoom-in" class="ui basic segment">
            <img class="ui image centered" style="width: 170px;" src="/img/logo_white7.png" alt="">
          </div>
          <div v-if="!show && whiteLabelLogo.length" data-aos="zoom-in" class="ui basic segment">
            <img class="ui image centered" style="width: 170px;" :src="whiteLabelLogo" alt="">
          </div>

<!-- 
          <div style="
  background: #f1f8f5;
  border-radius: 0.5rem;" class="ui basic segment">

<div class="ui fluid large form" style="margin-bottom: 1rem;">
   <div class="fields">
    <div class="six wide field">
      <label>Store Name</label>
      <input type="text" v-model="shopifyUrl" placeholder="coolshirts">
    </div>
    <div class="ten wide field">
      <label>URL Preview</label>
      <span style="
display: inline-block;
  padding: 0.6rem 1rem;
  background: #e3f9ed;
  border-radius: 0.5rem;
  width: 100%;
  color: #52886a;
      ">https://{{(shopifyUrl.length) ? shopifyUrl : '_ _ _ _ _ _' }}.myshopify.com</span>
    </div>
   </div>
</div>

<form id="auth" class="ui large form" :action="'https://'+ shopifyUrl +'.myshopify.com/admin/oauth/authorize'" method="get">

<input type="text" name="state" :value="JSON.stringify({ 'userId': '' , 'workspaceId': '' })" hidden>

<input type="text" name="client_id" :value="'2316679a1744bbd29e22e8b6134920e6'" hidden>

<input type="text" name="redirect_uri" :value="config.url + '/shopify/redirect'" hidden>

<input type="text" name="grant_options[]" value="per-user" hidden>

<input type="text" name="prompt" :value="'consent'" hidden>

<input type="text" name="scope" :value="'read_products,read_products,read_product_listings'" hidden>

<button type="submit" value="Submit" class="ui teal large fluid button">Signup with Shopify Account </button>
</form>

</div>

<div class="ui horizontal divider">
    Or
  </div> -->



          <div v-show="showLogin" class="ui basic segment">
            <div class="ui form">
              <div class="field">
                  <label>Email</label>
                  <input v-model="signIn.email" @input="signIn.email=$event.target.value.toLowerCase().trim()" placeholder="eric@southpark.com" type="text" :disabled="loading">
              </div>
              <div class="field">
                  <label>Password</label>
                  <input v-model="signIn.password" v-on:keyup.enter="signInFunc()" placeholder="Password" type="password" :disabled="loading">
              </div>
              <div v-show="error.email.invalid" class="ui negative mini message ">
                <p>{{error.message}}</p>
              </div>
              <div class="field">
                <button v-bind:class="{loading: loading}" :disabled="loading" @click="signInFunc()" class="ui orange button fluid">Login</button>
              </div>

            <!-- !!!!!! Gmaili sadece WhiteLabel olmayanlar için göster -->
            <div v-if="show" class="ui horizontal divider">OR</div>
              <form v-if="show" action="https://accounts.google.com/o/oauth2/auth" method="get" target="_blank">
                  <input type="text" name="client_id" value="958501235262-dhr2s7rhl7m2s0iteec832vfr3r76ni1.apps.googleusercontent.com" hidden>
                  <input type="text" name="redirect_uri" value="https://api.juphy.com/gmail/authentication" hidden>
                  <input type="text" name="response_type" value="code" hidden >
                  <input type="text" name="access_type" value="offline" hidden>

                  <!-- <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id, "partner_key": growSumoPartnerKey })" hidden> -->

                  <input type="text" name="scope" value="https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email" hidden>
                  
                  <button type="submit" value="Submit" class="ui google button fluid"><i class="icon google"></i> Login with Gmail </button>
              </form>

              <!-- <p v-show="show" style="font-size:12px; text-align: left; float: left;">Don't you have an account?  <router-link  to="/signup"><a href="">Sign Up</a></router-link></p> -->
              <p style="font-size:12px; text-align: right; float: right;">Forgot your password?  <router-link  to="/forgot"><a href="">Reset</a></router-link></p>
            </div>
          </div>     
        </div>
      </div>
</template>


// WEBPACK FOOTER //
// src/components/auth/Signin.vue